<template>
  <div>
    <md-content>
      <div v-if="Object.keys(errors).length">
        <template v-for="(error, index) in Object.values(errors)">
          <div
            :key="index"
            class="md-layout md-alignment-top-left hasError"
          >
            <span>{{ error }}</span>
          </div>
        </template>
      </div>
      <div class="form-container">
        <md-field>
          <span class="md-prefix">Email:</span>
          <md-input
            v-model.trim="$v.formData.email_address.$model"
            placeholder="Email:"
            required
          />
        </md-field>
        <div
          v-if="$v.formData.email_address.$error && !$v.formData.email_address.required"
          class="md-layout md-alignment-left-center error"
        >
          Email is required
        </div>
        <div
          v-if="$v.formData.email_address.$error && !$v.formData.email_address.email"
          class="md-layout md-alignment-left-center error"
        >
          Invalid Email
        </div>
      </div>
    </md-content>
    <div class="md-layout md-alignment-center-center"> 
      <md-button
        class="md-primary join-submit-button"
        @click="submitForm"
      >
        Login
      </md-button>
    </div>
    <div class="md-layout md-alignment-center-center"> 
      <p class="title">
        First time here? <span @click="goToRegister">Register</span>
      </p>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: "ContactForm",
  props: {
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return { 
      formData: {
        email_address: "",
      },
      formDataClone: { ...this.formData },
    }
  },
  validations: {
    formData: {
      email_address: { required, email }
    }
  },
  watch: {
    resetFrom(value) {
      if (!value) return
      this.formData = { ...this.formDataClone }
    },
  },
  methods: {
    async submitForm () {
      const toast = this.$toasted.show('Logining...')
      try {
        this.$v.$touch()
        if (this.$v.$invalid) {
          toast.goAway(0)
          return
        }
        const result = await this.$store.dispatch('checkUser',  this.formData.email_address)
        if (result.data.length) {
          window.location.replace('/tour')
          toast.text('Success').goAway(5000)
        } else {
          toast.goAway(0)
          this.$toasted.error('Email not registered!').goAway(5000)
        }
      } catch (error) {
        toast.goAway(0)
        this.$toasted.error('Unable to get information').goAway(5000)
        throw error(error)
      }
    },
    goToRegister() {
      this.$router.push('/joinEvent')
    }
  }
}
</script>
<style lang="scss" scoped>
.md-content {
    width: 100%;
    min-height: 105px;
    margin-top: 65px;
    margin-bottom: 33px;
    .form-container {
      padding: 38px 44px 41px 44px;
      .md-field {
        margin: 4px 0 10px !important;
        .md-prefix {
          color: #a1aeb7 !important;
          font-size: 14px;
          text-transform: uppercase;
          line-height: 1.71;
        }
        label {
          @extend .md-prefix;
        }
        input, textarea {
          &:focus {
            opacity: 1;
            &::placeholder {
              visibility: hidden !important;
              color: #a1aeb7;
            }
          }
          &::placeholder {
            @extend .md-prefix;
          }
        }
        &:before {
          background-color: #c2d1d9 !important;
        }
        &:after {
          background-color: #c2d1d9 !important;
        }
        &.md-focused {
          &:before {
            background-color: $color-primary !important;
          }
          &:after {
            background-color: $color-primary !important;
          }
        }
      }
      .error {
        position: relative;
        top: -5px;
        color: $color-primary;
        margin-bottom: -20px;
      }
    }
    .hasError {
      margin: 20px 0 -40px 40px;
      span {
        color: $color-primary;
      }
    }
  }
</style>
<style lang="scss">
.joint-radio-button {
  label {
    @extend .md-prefix;
    &.md-radio-label {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: #a1aeb7 !important;
    } 
  }
}
</style>